import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-pagination', 'title', 'Lehekülgede navigeerimine');
Labels.set('ui-pagination', 'previousPage', 'Eelmine leht');
Labels.set('ui-pagination', 'nextPage', 'Järgmine leht');
Labels.set('ui-pagination', 'currentPage', 'Käesolev leht');
Labels.set('ui-pagination', 'page', 'Leht');
Labels.set('ui-pagination', 'show', 'Näita leheküljel');
